import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner">
        {/* TPC Logo */}
        <img
          src="/TPC_only.png"
          alt="TPC Logo"
          className="loading-spinner-logo"
        />
        {/* Animated red arc */}
        <svg className="loading-spinner-circle" viewBox="0 0 100 100">
          <circle
            className="loading-spinner-arc"
            cx="50"
            cy="50"
            r="45"
            fill="none"
            stroke="#FF3100"
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray="94.25 188.5"
          />
        </svg>
      </div>
    </div>
  );
};

export default LoadingSpinner;
